import api from '../setup/axios';
import config from '../setup/config';

export default {
  async login(user) {    
    const response = await api.post(`${config.microservices.chatApi}/login`, user);
    return response.data;
  },
}